<script lang="ts">import { termsAndConditions } from "../data";
import { Container } from "@infinitro/container";
import { t, Verbiage } from "@infinitro/content";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
import "../api/api";
export let race;
export let raceId = undefined;
let startDate = new Date(race.startDate + "Z");
let endDate = new Date(race.endDate + "Z");
let vars = {
	startDate: startDate.toLocaleString(),
	endDate: endDate.toLocaleString()
};
</script>

<Container width="56.25rem">
	<div class="terms-and-conditions-container">
		<div class="terms-and-conditions-title">
			<Text
				type="title"
				titleWeight="bold"
				customStyle="font-size: 2rem !important;"
				textAlign="center"
			>
				{$t(Verbiage.terms_and_conditions_title, undefined, vars)}
			</Text>
		</div>
	</div>

	<InfoCard width="100%">
		<ol class="terms-and-conditions-list">
			{#each termsAndConditions as term}
				<li class="terms-and-conditions-list-item">
					<Text
						type="body"
						bodyWeight="regular"
						customStyle="font-size: 1rem !important;"
						textAlign="start"
						textColor="gray"
					>
						{$t(term, undefined, vars)}
					</Text>
				</li>
			{/each}
		</ol>
	</InfoCard>
</Container>

<style>
	.terms-and-conditions-title {

    margin-top: 1rem;

    margin-bottom: 1rem;

    text-transform: uppercase
}

	.terms-and-conditions-list {

    margin-top: 0.5rem;

    margin-bottom: 0.5rem;

    display: flex;

    list-style-type: decimal;

    flex-direction: column;

    gap: 1rem;

    padding-left: 2rem;

    padding-right: 2rem
}
</style>
